import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasCourseSchema = withDefaults({
  type: 'tas-course',
  objectExtensions: ['tas-course'],
  fields: [
    {
      kind: 'attribute',
      name: 'fields',
    },
    {
      kind: 'attribute',
      name: 'customFields',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isTrial',
    },
    {
      kind: 'belongsTo',
      name: 'tasApplication',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'tasCourses',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssets',
      type: 'tas-asset',
      options: {
        async: false,
        inverse: 'tasCourses',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasCourseSchema;
